var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabsIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 12.75H18.1667V15.6667H19.3334V13.9167H27.5C27.85 13.9167 28.0834 14.15 28.0834 14.5V20.9167C28.0834 21.2667 27.85 21.5 27.5 21.5H19.9167V25.5833H16.825L14.6667 27.275V25.5833H12.9167C12.5667 25.5833 12.3334 25.35 12.3334 25V18.5833C12.3334 18.2333 12.5667 18 12.9167 18H20.5V16.8333H12.9167C11.925 16.8333 11.1667 17.5917 11.1667 18.5833V25C11.1667 25.9917 11.925 26.75 12.9167 26.75H13.5V29.725L17.175 26.75H21.0834V22.6667H27.5C28.4917 22.6667 29.25 21.9083 29.25 20.9167V14.5C29.25 13.5083 28.4917 12.75 27.5 12.75Z",
    fill: "#FF3636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6166 24.3583H15.0166L15.3666 23.425H17.175L17.525 24.3583H18.925L16.9416 19.1667H15.5416L13.6166 24.3583ZM16.2416 20.625L16.825 22.4333H15.6583L16.2416 20.625Z",
    fill: "#FF3636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 20.9167C22.3084 20.9167 23.1834 20.7417 24 20.3333C24.8167 20.7417 25.75 20.9167 26.3334 20.9167V19.75C26.3334 19.75 25.75 19.75 25.1084 19.5167C25.8084 18.8167 26.3334 17.7667 26.3334 16.25V15.6667H24.5834V14.5H23.4167V15.6667H21.6667V16.8333H25.1084C24.9917 17.8833 24.525 18.525 24 18.9333C23.65 18.6417 23.3 18.2333 23.0667 17.7083H21.8417C22.075 18.4667 22.425 19.05 22.8917 19.5167C22.3084 19.75 21.7834 19.75 21.6667 19.75V20.9167Z",
    fill: "#FF3636"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FE0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabsIcon3);
export default __webpack_public_path__ + "static/media/tabs-icon3.2d57b9972465663f1e0ded214a378587.svg";
export { ForwardRef as ReactComponent };